import React from 'react'
import PropTypes from 'prop-types'

import PhoneNumber from 'lib/forms/phone-number'
import I18n from 'lib/i18n'

const Phone = ({ errors, phone, sessionCountry, onChange }) => (
  <div className={`form-element large ${errors.phone ? 'has-errors' : ''}`}>
    <label className='block'>{I18n.t('pages.contact.phone')}</label>
    <PhoneNumber value={phone} defaultCountry={sessionCountry} onChange={onChange} />
    {errors && errors.phone ? <div className='simple-error'>{errors.phone}</div> : null}
  </div>
)

export default Phone

Phone.propTypes = {
  onChange: PropTypes.func,
  phone: PropTypes.string,
  sessionCountry: PropTypes.string,
  errors: PropTypes.object
}
